import { Drawer } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { menuCloseDrawner, menuItemSelected } from "../../actions/menuAction";
import { fetchReports } from "../../actions/resourcesAction";
import { RootState } from "../../store/store";
import ResourcesList from "../ResourcesList";
import "../../styles/drawner.css"

const DrawerContainer = () => {
  const menuState = useSelector((state: RootState) => state.menu);
  const dispatch = useDispatch();

  useEffect(() => {
    //get all resources availables for the current user.
    dispatch(fetchReports());
  }, [dispatch]);

  const onCloseDrawer = () => {
    dispatch(menuCloseDrawner());
    dispatch(menuItemSelected("0"));
  };

  return (
    <Drawer
      data-testid={"drawer-list"}
      placement="left"
      width={300}
      onClose={onCloseDrawer}
      visible={menuState?.menu?.showDrawer}
      getContainer={false}
      style={{ position: "absolute" }}
    >
      <ResourcesList />
    </Drawer>
  );
};
export default DrawerContainer;
